module.exports = __webpack_public_path__ + "static/media/bluenotion-logo.bfb0412c.svg";